import React, { useEffect, useState } from "react";
import { RightOutlined } from "@ant-design/icons";
import { Select, Button } from "antd";
import { useLoader } from "../../Context/LoaderContext";
import jobDescriptionService from "../../Service/job.description.service";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./index.scss";
import { openNotification } from "../../Components/Notification";
import appIntegrationService from "../../Service/app.integration.service";

const ZohoRecruitProcess: React.FC = () => {
  const { setLoading, setLoadingMessage } = useLoader();
  const [selectedJobPost, setSelectedJobPost] = useState<string | undefined>(
    undefined
  );
  const [zohoJobPosts, setZohJobPosts] = useState<any[]>([]);
  const [searchParams] = useSearchParams();
  const candidateId = searchParams.get("candidateId");
  const navigate = useNavigate();

  const handleStartProcessing = async () => {
    if (!candidateId) {
      openNotification("error", "Invalid candidate Id", "");
      return;
    }

    if (!selectedJobPost) {
      openNotification("error", "Please select a job post to process the application", "");
      return;
    }

    setLoading(true);
    setLoadingMessage("Initializing processing...");

    try {
      const response =
        await appIntegrationService.processZohoRecruitApplication(
          candidateId,
          selectedJobPost
        );

      if (response.success) {
        openNotification(
          "success",
          response.message || "Processing Started",
          ""
        );
        const jobApplication = response.data;
        if (jobApplication?._id && jobApplication?.jobPost?._id) {
          navigate(
            `/application-details?applicationId=${jobApplication._id}&jobId=${jobApplication.jobPost._id}`
          );
        } else {
          navigate("/");
        }
      } else {
        openNotification("error", response.message || "Processing failed", "");
      }
    } catch (error) {
      setLoading(false);
      openNotification("error", "An error occurred while processing", "");
    } finally {
      setLoading(false);
      setLoadingMessage(null);
    }
  };

  const fetchZohoJobPosts = async () => {
    setLoading(true);
    setLoadingMessage("Loading job posts from Zoho Recruit...");
    const response = await jobDescriptionService.getAllZohoRecruitJobPosts();
    setZohJobPosts(response);
    setLoading(false);
    setLoadingMessage(null);
  };

  useEffect(() => {
    if (!candidateId) {
      openNotification("error", "Invalid Candidate Id", "");
      navigate(-1);
    }
  }, [candidateId]);

  useEffect(() => {
    fetchZohoJobPosts();
  }, []);

  const options = zohoJobPosts.map((j) => {
    return {
      value: j.jobPostId,
      label: j.jobPostTitle,
    };
  });

  return (
    <div className="zoho-recruit-process-container">
      <div className="zoho-recruit-process-content">
        <div className="logo-section">
          <img
            src="/images/zoho-recruit-logo.png"
            alt="Zoho Recruit"
            className="logo"
          />
        </div>

        <div className="arrow-container">
          <RightOutlined className="arrow-icon" />
        </div>

        <div className="logo-section">
          <img
            src="/images/qualifyme-logo-light.png"
            alt="QualifyMe"
            className="logo"
          />
        </div>
      </div>

      <div className="action-section">
        <Select
          placeholder="Select job post"
          value={selectedJobPost}
          onChange={setSelectedJobPost}
          className="job-post-select"
          style={{ width: 300 }}
          options={options}
          allowClear
        />
        <Button
          type="primary"
          onClick={handleStartProcessing}
          className="start-processing-button"
          disabled={!selectedJobPost}
        >
          Start Processing
        </Button>
      </div>
    </div>
  );
};

export default ZohoRecruitProcess;
